import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_yfWm7jX06p from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import floating_vue_EIcJ7xiw0h from "/app/.nuxt/floating-vue.mjs";
import plugin_FRmGFsEaPh from "/app/.nuxt/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import vue_easy_data_table_LA5Ed0hOi3 from "/app/plugins/vue.easy-data-table.ts";
import select2_client_1bxPA7cIia from "/app/plugins/select2.client.ts";
import vue_datepicker_client_OxG5HEUGtR from "/app/plugins/vue.datepicker.client.ts";
import vue_number_format_Ak6MufkB8O from "/app/plugins/vue.number.format.ts";
import vue_editor_q6jbjtYrWP from "/app/plugins/vue.editor.ts";
import apexcharts_VxzzcHGhhi from "/app/plugins/apexcharts.ts";
import vuetify_7h9QAQEssH from "/app/plugins/vuetify.ts";
import pinia_persisted_state_client_MhqBpdFkTy from "/app/plugins/pinia.persisted.state.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_yfWm7jX06p,
  floating_vue_EIcJ7xiw0h,
  plugin_FRmGFsEaPh,
  chunk_reload_client_UciE0i6zes,
  vue_easy_data_table_LA5Ed0hOi3,
  select2_client_1bxPA7cIia,
  vue_datepicker_client_OxG5HEUGtR,
  vue_number_format_Ak6MufkB8O,
  vue_editor_q6jbjtYrWP,
  apexcharts_VxzzcHGhhi,
  vuetify_7h9QAQEssH,
  pinia_persisted_state_client_MhqBpdFkTy
]